import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./Main";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />}></Route>
        <Route path="/*" element={<p>404</p>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
